const OPTIONS = {
  8: "xl:max-h-8",
  12: "xl:max-h-12",
  16: "xl:max-h-16",
  20: "xl:max-h-20",
  24: "xl:max-h-24",
  28: "xl:max-h-28",
  32: "xl:max-h-32",
  36: "xl:max-h-36",
  40: "xl:max-h-40",
  44: "xl:max-h-44",
  48: "xl:max-h-48",
  52: "xl:max-h-52",
  56: "xl:max-h-56",
  60: "xl:max-h-60",
  64: "xl:max-h-64",
  72: "xl:max-h-72",
  80: "xl:max-h-80",
  96: "xl:max-h-96",
};

export default function getMaxHeightXl(height) {
  return OPTIONS[height];
}
